const unHandleableStrings = ['and', 'of', 'or'];

const capitalize = (string) => {
  let newString = string.toLowerCase();
  const handleableStrings = newString
    .split(/\W/gm)
    .filter((item) => item && !unHandleableStrings.includes(item));
  const handledStrings = handleableStrings
    .map((item) => item.replace(item[0], item[0].toUpperCase()));
  handledStrings.forEach((item, index) => {
    newString = newString.replace(handleableStrings[index], item);
  });
  return newString;
};

export default capitalize;
